module.exports = __webpack_public_path__ + "media/images/top/option-1fead44f696a1c38914e49c57c7f6922.svg";